import { ESpamListActionTypes, ISpamListRequest } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { TChatListSetSucceedPayload } from '../chatList';

/**
 * Запрос за списком спам чатов
 */
export const setSpamListPending = actionGenerator<ESpamListActionTypes.SetPending, ISpamListRequest>(
  ESpamListActionTypes.SetPending,
);

/**
 * Установить список спам чатов
 */
export const setSpamListSucceed = actionGenerator<ESpamListActionTypes.SetSucceed, TChatListSetSucceedPayload>(
  ESpamListActionTypes.SetSucceed,
);

/**
 * Установить ошибку запроса списка спам чатов
 */
export const setSpamListFailed = actionGenerator<ESpamListActionTypes.SetFailed, void>(ESpamListActionTypes.SetFailed);
